import React, { ReactElement } from 'react';
import { connect } from 'react-redux';
import { AxiosError } from 'axios';
import { sessionViewSelectors } from '../../../../../../redux/views/session-view/session/slice';
import { RootState } from '../../../../../../redux/store';
import {
  publicLaunchPanelApi,
  useGetPublicLaunchPanelQuery,
} from '../../../../../../redux/views/session-view/launch-panel/publicApi';
import { determineShouldSkip } from './utils/utils';
import { LaunchPanelTabContent } from './index';

const PublicLaunchPanelTabContentContainer = ({
  sessionActiveTab,
  sessionUid,
  versionUid,
  publicAccessKey,
}: PublicLaunchPanelTabContentContainerProps): ReactElement => {
  const { useQueryState } = publicLaunchPanelApi.endpoints.getPublicLaunchPanel;
  const { data: existingData } = useQueryState({
    publicAccessKey,
    sessionUid,
    versionUid,
  });

  const { data, isLoading, isError, isFetching, refetch, error } =
    useGetPublicLaunchPanelQuery(
      { publicAccessKey, sessionUid, versionUid },
      {
        skip: determineShouldSkip({ existingData, sessionActiveTab }),
      },
    );

  return (
    <LaunchPanelTabContent
      error={error as AxiosError}
      sessionActiveTab={sessionActiveTab}
      isError={isError}
      isLoading={isLoading}
      isFetching={isFetching}
      embeddedAppUrl={data?.url || existingData?.url}
      refetch={refetch}
    />
  );
};

type ConnectedPublicLaunchPanelTabContentOwnProps = {
  sessionUid: string;
  versionUid: string;
  publicAccessKey: string;
};

const mapStateToProps = (
  state: RootState,
  ownProps: ConnectedPublicLaunchPanelTabContentOwnProps,
) => ({
  sessionActiveTab: sessionViewSelectors.getSessionActiveTab(state),
  ...ownProps,
});

type PublicLaunchPanelTabContentContainerProps = ReturnType<
  typeof mapStateToProps
>;

export const ConnectedPublicLaunchPanelTabContent = connect(mapStateToProps)(
  PublicLaunchPanelTabContentContainer,
);
